var PROGRESS_STEPS_ORDER = [
    'add_group',
    'provide_passwords',
    'login_students',
    'first_run',
];
export { PROGRESS_STEPS_ORDER };
